module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-without-heading",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Incandescent trees hide presents bought.")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("A tale of a saviour’s birth,")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("A child")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Empowered to save the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("A fear insidious, a vengeance sought.")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("A cry for help amidst darkness")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Developing feelings fraught.")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Unjoyful.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42513e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 78
// module chunks = 0